



















































































import "@/assets/css/split.css";
import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import AbpBase from "@/lib/abpbase";
import PageRequest from "@/store/entities/page-request";
class PageUserRequest extends PageRequest {
  menuId: string;
  tableName: string;
}

@Component({
  components: {},
})
export default class UserField extends AbpBase {
  pagerequest: PageUserRequest = new PageUserRequest();
  treedata: [] = [];
  menudata: any[] = [];
  itemId: string = "0";
  height: number = 300; //表格高度
  loadingdata: boolean = false;
  splitnum: number = 0.15;

  get list() {
    return this.$store.state.userfield.list;
  }
  get loading() {
    return this.$store.state.userfield.loading;
  }
  async itemtree() {
    await this.$store
      .dispatch({ type: "userfield/getusermenu", data: this.pagerequest })
      .then((val) => {
        this.treedata = val.item1;
        this.menudata = val.item2;
      })
      .catch((err) => {
        //return null;
      });
  }
  pageChange(page: number) {
    this.$store.commit("userfield/setCurrentPage", page);
    this.getpage();
  }
  pagesizeChange(pagesize: number) {
    this.$store.commit("userfield/setPageSize", pagesize);
    this.getpage();
  }
  changeSort(key) {
    this.pagerequest.sorting = key.key + " " + key.order;
    this.getpage();
  }
  getItemId() {
    let item = (this.$refs.tree as any).getSelectedNodes();
    if (item.length == 0) {
      return;
    }
    this.pagerequest.tableName = "";
    let tag = item[0].description;
    switch (tag) {
      case "meters": //表计
        this.pagerequest.tableName = "kd_meter";
        break;
      case "meterModel": //表计模型
        this.pagerequest.tableName = "kd_metermodel";
        break;
      case "meterinfo": //表计信息
        this.pagerequest.tableName = "kd_meterinfo";
        break;
      case "collectorinfo": //采集器信息
        this.pagerequest.tableName = "kd_collectorinfo";
        break;
      case "collectors": //采集器
        this.pagerequest.tableName = "kd_collector";
        break;
      case "onoffcontrol": //开关控制
        this.pagerequest.tableName = "kd_meterinfo";
        break;
      case "recharge": //充值缴费
        this.pagerequest.tableName = "kd_meterinfo";
        break;
      case "totalmeterinfo": //大表信息
        this.pagerequest.tableName = "kd_meterinfo";
        break;
      case "personmeterinfo": //户表
        this.pagerequest.tableName = "kd_meterinfo";
        break;
      case "pressure": //压力计
        this.pagerequest.tableName = "kd_pressure";
        break;
      case "pressureinfo": //压力计信息
        this.pagerequest.tableName = "kd_pressureinfo";
        break;
      case "pressuremodal": //压力计模型
        this.pagerequest.tableName = "kd_pressuremodel";
        break;
      case "price": //价格
        this.pagerequest.tableName = "kf_price";
        break;
      default:
        break;
    }
    if (this.pagerequest.tableName == "") {
      this.$Modal.info({
        title: this.L("Tips"),
        content: this.L("MenuNoColumn"),
      });
    }
    this.pagerequest.menuId = item[0].id;
    this.$store.commit("userfield/setCurrentPage", 1);
    this.getpage();
  }
  getSearch() {
    this.$store.commit("userfield/setCurrentPage", 1);
    this.getpage();
  }
  async getpage() {
    this.pagerequest.maxResultCount = this.pageSize;
    this.pagerequest.skipCount = (this.currentPage - 1) * this.pageSize;
    let res = await this.$store
      .dispatch({
        type: "userfield/getuserfield",
        data: this.pagerequest,
      })
      .then((res) => {
        this.$store.state.userfield.list = res;
      });
  }
  get pageSize() {
    return this.$store.state.userfield.pageSize;
  }
  get totalCount() {
    return this.$store.state.userfield.totalCount;
  }
  get currentPage() {
    return this.$store.state.userfield.currentPage;
  }
  //保存
  async save() {
    this.loadingdata = true;
    await this.$store
      .dispatch({
        type: "userfield/updatelist",
        data: this.$store.state.userfield.list,
      })
      .then((val) => {
        this.loadingdata = false;
        this.$Modal.info({
          title: this.L("Tips"),
          content: val,
        });
      })
      .catch((err) => {
        this.loadingdata = false;
        this.$Modal.info({
          title: this.L("Tips"),
          content: err,
        });
      });
    this.loadingdata = false;
  }
  columns = [
    {
      type: "index",
      width: 80,
      align: "left",
      title: this.L("IndexNo"),
    },
    {
      title: this.L("Name"),
      key: "showTag",
      render: (h: any, params: any) => {
        return h(
          "span",
          {
            style: {
              display: "inline-block",
              width: "100%",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            },
            domProps: {
              title: this.L(
                params.row.fieldName == "No" ? "Number" : params.row.showTag
              ),
            },
          },
          this.L(params.row.fieldName == "No" ? "Number" : params.row.showTag)
        );
      },
    },
    {
      title: this.L("Field"),
      key: "fieldName",
      sortable: true,
    },
    {
      title: this.L("IsShow"),
      key: "isShow",
      render: (h: any, params: any) => {
        let self = this;
        return h("Checkbox", {
          props: {
            value: params.row.isShow,
          },
          domProps: {
            value: params.row.isShow,
          },
          on: {
            input: function (event) {
              const index = params.index;
              self.$store.state.userfield.list[index].isShow = event;
            },
          },
        });
      },
    },
    {
      title: this.L("SortCode"),
      key: "sortCode",
      sortable: true,
      render: (h: any, params: any) => {
        let self = this;
        return h("Input", {
          props: {
            value: params.row.sortCode,
          },
          domProps: {
            value: params.row.sortCode,
          },
          on: {
            input: function (event) {
              const index = params.index;
              self.$store.state.userfield.list[index].sortCode = event;
            },
          },
        });
      },
    },
  ];
  async created() {
    //this.getpage();
    this.itemtree();
  }
  mounted() {
    if (window.innerHeight > 800) {
      this.height = window.innerHeight - 330;
    } else {
      this.height = window.innerHeight - 370;
    }
  }
}
